import jsnormalizeExport from 'json-api-normalizer'

/**
 * The package is CJS with `exports.default`, so an interop that unwraps the marker hands over
 * the function and one that follows the spec hands over `{ default: fn }`. The difference is
 * silent: `normalizeSafe` catches the TypeError and every response folds to no entities.
 */
const jsnormalize: typeof jsnormalizeExport =
  typeof jsnormalizeExport === 'function' ? jsnormalizeExport : (jsnormalizeExport as { default: typeof jsnormalizeExport }).default

type ApiType = {
  id: string | number
  type: string
}

type Payload = {
  data: ApiType | ApiType[]
}

type DataType<T extends ApiType | ApiType[]> = T extends ApiType[] ? T[number] : T
type IncludedType<T extends ApiType[] | undefined> = Exclude<T, undefined>[number]

type PayloadTypes<P extends Payload> = DataType<P['data']> | (P extends { included?: ApiType[] } ? IncludedType<P['included']> : never)

export type ApiTypesMap<P extends ApiType> = { [K in P['type']]?: { [key: string]: Extract<P, { type: K }> } }

/** wrapper for `json-api-normalizer` that forbids camelizing of properties*/
export const normalize = <P extends Payload>(input: P): ApiTypesMap<PayloadTypes<P>> => jsnormalize(input, { camelizeKeys: false, camelizeTypeValues: false })

/** `normalize` for a payload that may not be a JSON:API document at all — folds what it can, naming the types you expect. */
export const normalizeSafe = <E extends ApiType>(payload: unknown): ApiTypesMap<E> => {
  try {
    return normalize(payload as Payload) as ApiTypesMap<E>
  } catch {
    return {}
  }
}
